import React from 'react';
import { colors } from 'styleguide';

interface Props {
  size?: number;
  color?: {
    primary: string;
    secondary: string;
  };
}

const Card = ({
  size = 32,
  color = { primary: colors('purple'), secondary: colors('purple', 2) },
}: Props) => (
  <svg width={size} height={size} fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="32" width="32" height="32" rx="2" transform="rotate(90 32 0)" fill={color.primary} />
    <path
      d="M22 19l3-3-3-3M10 13l-3 3 3 3"
      fill={color.secondary}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="16" r="1" fill={color.secondary} />
    <circle cx="16" cy="16" r="1" fill={color.secondary} />
    <circle cx="20" cy="16" r="1" fill={color.secondary} />
  </svg>
);

export default Card;
